export class VehicleSourceConsts {

  static EUROTAX = 'EUROTAX';
  static INFOEXPERT_LINK4 = 'INFOEXPERT_LINK4';
}
